import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {Context} from 'src/common/types'
import {DefaultTop10AiTools} from './DefaultTop10AiTools'

export type Top10AiToolsProps = SliceComponentProps<Content.Top10AiToolsSlice>

const Top10AiTools = ({
  slice,
  context: {pageUid, buttonsData},
  index: componentIndex,
}: Top10AiToolsProps & {context: Context}): JSX.Element => {
  switch (slice.variation) {
    default:
      return (
        <DefaultTop10AiTools
          slice={slice}
          pageUid={pageUid}
          componentIndex={componentIndex}
          buttonsData={buttonsData}
        />
      )
  }
}

export default Top10AiTools
